import { onlineManager, useSuspenseQueries } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v4'
import { queryKeys } from '@/queries/keys'
import {
  getBookingQueryOptions,
  getBookingTransportationQueryOptions,
  getListDateTypesQueryOptions,
  getListDatesQueryOptions,
} from '@/queries/query'
import DatePage from '@/pages/make-booking/bus-details/Date'
import { PageWithRedirectSearchSchema } from '@/schemas/page'

function getYearMonth(date = new Date()) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

export const Route = createFileRoute(
  '/make-booking/$id/bus-details/$transportationId/date/',
)({
  validateSearch: z.object({
    ...PageWithRedirectSearchSchema.shape,
    month: z.string().default(getYearMonth()),
  }),
  loaderDeps: ({ search }) => {
    return {
      month: search.month,
    }
  },
  loader: ({ context, params, deps }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return [
        context.queryClient.ensureQueryData(
          getBookingTransportationQueryOptions(params.transportationId),
        ),
        context.queryClient.ensureQueryData(
          getListDatesQueryOptions({
            id: params.transportationId,
            month: deps.month,
          }),
        ),
        context.queryClient.ensureQueryData(
          getListDateTypesQueryOptions({
            id: params.transportationId,
            month: deps.month,
          }),
        ),
      ]
    }
    return [
      context.queryClient.getQueryData(
        queryKeys.booking.transportation(params.transportationId),
      ),
      context.queryClient.getQueryData(
        queryKeys.booking.date({
          id: params.transportationId,
          month: deps.month,
        }),
      ),
      context.queryClient.getQueryData(
        queryKeys.booking.dateTypes({
          id: params.transportationId,
          month: deps.month,
        }),
      ),
    ]
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { id, transportationId } = Route.useParams()
  const [
    {
      data: {
        data: { booking },
      },
    },
    {
      data: {
        data: { booked_transportation: transportation },
      },
    },
  ] = useSuspenseQueries({
    queries: [
      getBookingQueryOptions(id),
      getBookingTransportationQueryOptions(transportationId),
    ],
  })
  return <DatePage booking={booking} transportation={transportation} />
}
